<script>
	import { emailValidator } from './utils.js'
	// metatags.title = 'DevPortal - Riscognition'
	// metatags.description = 'Developer Portal for the Riscognition API'

	let email;
	let msg = "";

	const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
	}

	function handleKeyUp(e) {
		if (e.key === "Enter") {
			handleSubmit()
		}
	}

	function handleSubmit() {
			if (emailValidator(email)) {
				msg = ""
				fetch("/", {
					method: "POST",
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
					body: encode({ "form-name": "subscription", email })
				})
        .then(() => {
					msg = "🙌 Thank you!"
					email = ""
				})
        .catch(error => console.log(error));
			} else {
				msg = "☝️ Please enter a valid email!"
			}
    };
</script>

<div class="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-0 max-w-5xl">
	<!-- <div class="md:col-span-3 flex items-end"><h2 class="text-xl ml-3 md:ml-0 md:text-2xl mb-5"></h2></div> -->
	<div class="md:col-span-2"><h1 class="text-3xl md:text-4xl lg:text-5xl md:pr-5 text-center md:text-left mt-8">Earth Observation Data-Services and Monitoring from Space 🛰️</h1></div>
	<div class="col-span-1"><img class="h-auto mx-auto py-3 md:py-0" src="/images/undraw_data_trends_b0wg.svg" alt="undraw"></div>
	<div class="md:col-span-2"><p class="text-center md:text-left py-5 md:py-0 text-lg font-medium md:text-2xl">Ready to give your application an EO boost?</p>
		<p class="text-center md:text-left py-0 md:py-0 text-base font-normal md:text-xl">Check out our <a class="underline" href="/docs" tinro-ignore>Docs</a> to learn more about our services.</p>
	</div>
	<div class="col-span-1 flex flex-col box-border overflow:auto mx-3 md:px-0">
		<h3 class="text-xl lg:text-2xl md:pr-4 text-indigo-900 mb-4">Get notified when we launch new services</h3>
		<div name="subscription" method="POST" class="flex box-border">
			<input bind:value={email} on:keyup={handleKeyUp} class="flex-1 min-w-0 h-10 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mr-2" type="text" placeholder="Enter Email">
			<button on:click={handleSubmit} class="h-10 bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-3 border border-blue-500 hover:border-transparent rounded">
				Subscribe
			</button>
		</div>
		<span class="h-5 text-sm mt-1">{msg}</span>
	</div>
</div>
